export const getRandomWordsList = (_data: any) => {
  const randomIndex1 = Math.floor(Math.random() * _data.length);
  let randomIndex2 = Math.floor(Math.random() * _data.length);
  while (randomIndex1 === randomIndex2) {
    randomIndex2 = Math.floor(Math.random() * _data.length);
  }
  return [..._data[randomIndex1], ..._data[randomIndex2]];
};

export const wordsPresentedFromKeyValList = (keyValList: any): string[] => {
  return keyValList?.map((keyValPair: any) => keyValPair.value);
};
